import { render, staticRenderFns } from "./任务栏.vue?vue&type=template&id=a4aed6f4&scoped=true&"
import script from "./任务栏.vue?vue&type=script&lang=js&"
export * from "./任务栏.vue?vue&type=script&lang=js&"
import style0 from "./任务栏.vue?vue&type=style&index=0&id=a4aed6f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4aed6f4",
  null
  
)

export default component.exports